import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0a97947e = () => interopDefault(import('../../../src/pages/banned.vue' /* webpackChunkName: "src/pages/banned" */))
const _36ff2394 = () => interopDefault(import('../../../src/pages/cab.vue' /* webpackChunkName: "src/pages/cab" */))
const _ad459420 = () => interopDefault(import('../../../src/pages/cab/blocklist.vue' /* webpackChunkName: "src/pages/cab/blocklist" */))
const _30ab7af9 = () => interopDefault(import('../../../src/pages/cab/invoice-history.vue' /* webpackChunkName: "src/pages/cab/invoice-history" */))
const _26414a17 = () => interopDefault(import('../../../src/pages/cab/messages.vue' /* webpackChunkName: "src/pages/cab/messages" */))
const _ff6d0c9a = () => interopDefault(import('../../../src/pages/cab/private-call.vue' /* webpackChunkName: "src/pages/cab/private-call" */))
const _26f9512e = () => interopDefault(import('../../../src/pages/cab/profile.vue' /* webpackChunkName: "src/pages/cab/profile" */))
const _09ef97dc = () => interopDefault(import('../../../src/pages/cab/profile-settings.vue' /* webpackChunkName: "src/pages/cab/profile-settings" */))
const _bcc87a50 = () => interopDefault(import('../../../src/pages/cab/stories.vue' /* webpackChunkName: "src/pages/cab/stories" */))
const _b7edcca6 = () => interopDefault(import('../../../src/pages/cab/top-profiles.vue' /* webpackChunkName: "src/pages/cab/top-profiles" */))
const _98a80316 = () => interopDefault(import('../../../src/pages/cab/video-chat.vue' /* webpackChunkName: "src/pages/cab/video-chat" */))
const _68840dac = () => interopDefault(import('../../../src/pages/double-connection.vue' /* webpackChunkName: "src/pages/double-connection" */))
const _0f36b85c = () => interopDefault(import('../../../src/pages/auth/create-new-password.vue' /* webpackChunkName: "src/pages/auth/create-new-password" */))
const _91d30356 = () => interopDefault(import('../../../src/pages/auth/email.vue' /* webpackChunkName: "src/pages/auth/email" */))
const _6b5ca2e7 = () => interopDefault(import('../../../src/pages/auth/email-confirmed.vue' /* webpackChunkName: "src/pages/auth/email-confirmed" */))
const _22c4da04 = () => interopDefault(import('../../../src/pages/auth/forgot-password.vue' /* webpackChunkName: "src/pages/auth/forgot-password" */))
const _43870431 = () => interopDefault(import('../../../src/pages/auth/login-email.vue' /* webpackChunkName: "src/pages/auth/login-email" */))
const _96c250c2 = () => interopDefault(import('../../../src/pages/auth/registration-email.vue' /* webpackChunkName: "src/pages/auth/registration-email" */))
const _5b4742ce = () => interopDefault(import('../../../src/pages/auth/registration-gender.vue' /* webpackChunkName: "src/pages/auth/registration-gender" */))
const _ad9a6250 = () => interopDefault(import('../../../src/pages/auth/registration-name.vue' /* webpackChunkName: "src/pages/auth/registration-name" */))
const _1a0776db = () => interopDefault(import('../../../src/pages/auth/welcome.vue' /* webpackChunkName: "src/pages/auth/welcome" */))
const _091cb0bc = () => interopDefault(import('../../../src/pages/index.vue' /* webpackChunkName: "src/pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/banned",
    component: _0a97947e,
    name: "banned___en"
  }, {
    path: "/cab",
    component: _36ff2394,
    name: "cab___en",
    children: [{
      path: "blocklist",
      component: _ad459420,
      name: "cab-blocklist___en"
    }, {
      path: "invoice-history",
      component: _30ab7af9,
      name: "cab-invoice-history___en"
    }, {
      path: "messages",
      component: _26414a17,
      name: "cab-messages___en"
    }, {
      path: "private-call",
      component: _ff6d0c9a,
      name: "cab-private-call___en"
    }, {
      path: "profile",
      component: _26f9512e,
      name: "cab-profile___en"
    }, {
      path: "profile-settings",
      component: _09ef97dc,
      name: "cab-profile-settings___en"
    }, {
      path: "stories",
      component: _bcc87a50,
      name: "cab-stories___en"
    }, {
      path: "top-profiles",
      component: _b7edcca6,
      name: "cab-top-profiles___en"
    }, {
      path: "video-chat",
      component: _98a80316,
      name: "cab-video-chat___en"
    }]
  }, {
    path: "/double-connection",
    component: _68840dac,
    name: "double-connection___en"
  }, {
    path: "/auth/create-new-password",
    component: _0f36b85c,
    name: "auth-create-new-password___en"
  }, {
    path: "/auth/email",
    component: _91d30356,
    name: "auth-email___en"
  }, {
    path: "/auth/email-confirmed",
    component: _6b5ca2e7,
    name: "auth-email-confirmed___en"
  }, {
    path: "/auth/forgot-password",
    component: _22c4da04,
    name: "auth-forgot-password___en"
  }, {
    path: "/auth/login-email",
    component: _43870431,
    name: "auth-login-email___en"
  }, {
    path: "/auth/registration-email",
    component: _96c250c2,
    name: "auth-registration-email___en"
  }, {
    path: "/auth/registration-gender",
    component: _5b4742ce,
    name: "auth-registration-gender___en"
  }, {
    path: "/auth/registration-name",
    component: _ad9a6250,
    name: "auth-registration-name___en"
  }, {
    path: "/auth/welcome",
    component: _1a0776db,
    name: "auth-welcome___en"
  }, {
    path: "/",
    component: _091cb0bc,
    name: "index___en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
